{
    "Api tokens": {
        "add token": "",
        "description": "",
        "example": "",
        "generate token": "",
        "generated token": "",
        "last used at": "Usado por último em",
        "name": "Nome do token API",
        "never": "Nunca",
        "no tokens": "Nenhum token disponível",
        "no tokens description": "",
        "show token list": "",
        "titles": {
            "Integration": {
                "description": "",
                "name": ""
            },
            "Tct": {
                "description": "",
                "name": ""
            }
        },
        "tokens": "Tokens API",
        "token type": "",
        "token was created": ""
    },
    "Attributes": {
        "Completed": "Concluído",
        "Count": "Quantidade",
        "Current": "Atual",
        "Date": "Data",
        "Empty": "Vazios",
        "excluded files": "",
        "Failed": "Falhou",
        "Feature": "Característica",
        "file size bytes": "",
        "File_type": "Tipo do arquivo",
        "File_version": "Versão do arquivo",
        "Fingerprint_id": "",
        "Firmware_date": "Data do firmware",
        "Firmware_version": "",
        "included files": "",
        "Message": "Mensagem",
        "Metadata": "",
        "newest": "De mais recente",
        "oldest": "De mais antiga",
        "Order": "Seqüência",
        "Password_source": "",
        "Pending": "Pendente",
        "Period": "Período",
        "Process_id": "",
        "Protocol_id": "ID do protocolo",
        "specific": "Específico",
        "Start": "Iniciar",
        "SystemGenerated": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "",
            "fw_bundle_ble_dtb": "",
            "fw_bundle_can": "",
            "fw_bundle_can_dtb": "",
            "fw_bundle_dtb": "",
            "fw_bundle_mainfw": ""
        },
        "UserEntered": "",
        "vehicle": "",
        "Vehicle_id": "",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "",
            "check email": "",
            "code required": "",
            "code sent to email": "",
            "code valid": "",
            "enter code below": "",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "",
        "check email": "Verifique a sua caixa de entrada e clique no link recebido para redefinir uma senha.",
        "community forum": "Fórum da comunidade",
        "contact us": "",
        "create initial password": "Criar uma senha",
        "create password": "Criar senha",
        "did not receive": "Não recebeu o link?",
        "do not have account": "",
        "email": "Email",
        "enter email": "Por favor, digite seu e-mail registrado abaixo para receber instruções de redefinição de senha.",
        "forgot password": "Esqueceu a senha?",
        "forgot your password": "Esqueceu a sua senha?",
        "for ms365": "",
        "invalid email format": "Formato de email inválido",
        "invalid password format": "Formato de senha inválido",
        "link sent": "O link foi enviado!",
        "length": "Mínimo 8 caracteres",
        "lowercase": "Contém pelo menos 1 letra minúscula",
        "new password": "Nova senha",
        "password": "Senha",
        "passwords do not match": "As senhas não coincidem",
        "privacy policy": "Ao usar o FOTA WEB, você concorda com nossa <1>política de privacidade</1>.",
        "remember password": "Você se lembra da sua senha?",
        "repeat password": "Repetir senha",
        "required": "Requerido",
        "resend": "Reenviar",
        "reset password": "Redefinir senha",
        "send reset link": "Enviar link de redefinição",
        "sign in": "Entrar",
        "sign in to fota": "",
        "signup": "Inscrever-se",
        "sso": "",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Letra maiúscula",
        "user consent text": "",
        "welcome": "Bem-vindo a",
        "wiki": "Base de conhecimento Wiki Telematics"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "",
        "accept all": "",
        "accept selected": "",
        "actions": "",
        "add": "Adicionar",
        "add device": "",
        "add more files": "",
        "add new": "",
        "agree": "",
        "all companies": "",
        "all of company": "",
        "all rows selected": {
            "devices": "",
            "tasks": "",
            "groups": "",
            "files": "",
            "companies": "",
            "users": ""
        },
        "approve": "Aprovar",
        "assign": "",
        "assigning": "",
        "auto sync": "",
        "back": "",
        "back to sign in": "",
        "cancel": "Cancelar",
        "cancelling": "",
        "cancel all tasks in group": "",
        "cancel tasks": "Cancelar tarefas",
        "cannot create desktop licenses": "",
        "cannot create offline licenses": "",
        "change": "Alterar",
        "clear all": "",
        "clear all filters": "",
        "close": "Fechar",
        "company settings": "",
        "confirm": "Confirmar",
        "continue": "",
        "copied": "Copiado",
        "copy all": "",
        "copy to clipboard": "",
        "create": "Criar",
        "create role": "",
        "create task": "Criar tarefa",
        "creating": "",
        "default view": "",
        "delete": "Excluir",
        "deleting": "",
        "deselect all": "",
        "device": "",
        "disable": "",
        "disagree": "",
        "discard": "",
        "download": "",
        "edit": "Editar",
        "enable": "",
        "export": "Exportar",
        "exporting": "",
        "filters": "Filtros",
        "finish": "",
        "find tool": "",
        "first page": "",
        "fmx and legacy": "",
        "ft platform": "",
        "generate": "",
        "generate codes": "",
        "go back": "",
        "import": "",
        "importing": "",
        "invite": "",
        "invite user": "",
        "invite user to internal disabled": "",
        "language": "Idioma",
        "last page": "",
        "logout": "Sair",
        "maximize details": "",
        "merge": "Mesclar",
        "merging": "",
        "minimize details": "",
        "more actions": "",
        "more filters": "",
        "more options": "",
        "move": "Mover",
        "moving": "",
        "next": "Próximo",
        "next month": "",
        "next page": "",
        "no actions available": "",
        "no permission": "",
        "no permissions": "",
        "notify when done": "",
        "number of selected companies": "",
        "only essential": "",
        "open fota web": "",
        "pages of": "",
        "previous month": "",
        "previous page": "",
        "print": "",
        "receive devices": "",
        "refresh page": "",
        "reject all": "",
        "reset to default": "",
        "retry failed tasks": "",
        "retrying": "",
        "return home": "",
        "revert manual level change": "",
        "rows count per page": "",
        "rows selected": "",
        "save": "Guardar",
        "saving": "",
        "see all": "",
        "select all": {
            "devices": "",
            "tasks": "",
            "groups": "",
            "files": "",
            "companies": "",
            "users": ""
        },
        "select columns to show": "",
        "selected page is first": "",
        "selected page is last": "",
        "select rows": "",
        "send code": "",
        "settings": "Configurações",
        "show me": "",
        "show more": "",
        "synchronize": "",
        "table statistics": "",
        "table view": "",
        "transfer": "",
        "transferring": "",
        "transfer my devices": "",
        "undo": "",
        "upload": "Carregar",
        "upload file": "Carregar novo arquivo",
        "user": "",
        "verify": "",
        "yes": ""
    },
    "Cookies": {
        "always active": "",
        "analytics cookies": "",
        "analytics cookies description": "",
        "cookie banner message": "",
        "cookie modal title": "",
        "cookie policy": "",
        "essential cookies": "",
        "essential cookies description": ""
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "",
                "Standard": "",
                "Premium": ""
            },
            "resource limit types": {
                "Companies": "",
                "Users": "",
                "ConfigurationFiles": ""
            }
        },
        "empty state": {
            "description": {
                "configurations": "",
                "firmware versions": ""
            },
            "title": {
                "configurations": "",
                "firmware versions": "",
                "news": ""
            }
        },
        "imported activated devices": {
            "days": {
                "1": "",
                "7": "",
                "30": "",
                "90": ""
            },
            "period": ""
        },
        "new": "",
        "news": {
            "body": {
                "1": "",
                "2": "",
                "3": "",
                "4": "",
                "5": "",
                "6": "",
                "7": "",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "",
                "2": "",
                "3": "",
                "4": "",
                "5": "",
                "6": "",
                "7": "",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "",
        "take me there": "",
        "tasks": {
            "current": "",
            "status": {
                "completed": "",
                "completed_with_errors": "",
                "failed": "",
                "no tasks": ""
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "",
                "tooltipTitle": ""
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "",
                "tooltipTitle": ""
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "",
                "tooltipTitle": ""
            }
        },
        "title": {
            "activated": "",
            "configurations": "Configurações",
            "device status": "Status do dispositivo",
            "firmware versions": "Versões de firmware",
            "imported": "",
            "news": "",
            "queued tasks": "",
            "refreshed every hour": "",
            "resource limits": "",
            "task overview": "",
            "tasks": "Tarefas"
        },
        "tooltips": {
            "activated": "",
            "configurations": "",
            "firmware versions": "",
            "imported": ""
        }
    },
    "Date picker": {
        "disableFuture": "",
        "disablePast": "",
        "invalidDate": "",
        "maxDate": "Data errada",
        "minDate": "Data errada",
        "shouldDisableDate": "",
        "shouldDisableMonth": "",
        "shouldDisableYear": ""
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Adicionar novo dispositivo",
        "add new device description": "",
        "add new device legacy title": "",
        "add new device legacy description": "",
        "add new product code": "",
        "add new product code description": "",
        "all permissions": "",
        "assign access group": "",
        "assign can package description": "",
        "assign role": "",
        "attribute value": "",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Iniciar download",
        "by date": "",
        "by time": "",
        "can adapter": "Adaptador CAN",
        "cancel pending tasks": "",
        "cancel tasks": "Cancelar tarefas",
        "cancel tasks in group": {
            "alert title": "",
            "banner description": "",
            "banner title": "",
            "description": "",
            "title": ""
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "",
        "companies": "Empresas",
        "company": "",
        "company level": {
            "Basic": "",
            "Internal": "",
            "Premium": "",
            "Standard": ""
        },
        "company level change description": "",
        "company level manual revert": {
            "confirmation": {
                "description": "",
                "title": ""
            },
            "description": "",
            "title": ""
        },
        "company level type": "",
        "company name": "Nome da empresa",
        "company statistics": {
            "child companies": "",
            "devices": "",
            "files": "",
            "groups": "",
            "tasks": "",
            "users": ""
        },
        "company type": {
            "All": "",
            "Client": "",
            "Internal": "",
            "Virtual": ""
        },
        "configuration": "Configuração",
        "confirmations": {
            "are you sure": "",
            "are you sure you wish to continue": "",
            "assign can package confirmation": "",
            "cancel task confirmation": {
                "first part": "",
                "second part": ""
            },
            "create task confirmation": "",
            "delete resource confirmation": {
                "first part": "",
                "second part": ""
            },
            "delete resources": {
                "companies": "",
                "files": "",
                "groups": "",
                "deviceModels": "",
                "productCodes": "",
                "roles": "",
                "users": ""
            },
            "description second part": "",
            "export device data confirmation": "",
            "file": "Insira o número de linhas, existente no arquivo",
            "filter": {
                "companies": "Insira o número de empresas filtradas",
                "devices": "Insira o número de dispositivos filtrados",
                "files": "Insira o número de arquivos filtrados",
                "groups": "Insira o número de grupos filtrados",
                "productCodes": "",
                "tasks": "Insira o número de tarefas filtradas",
                "users": "Insira o número de usuários filtrados"
            },
            "id_list": {
                "companies": "Insira o número de empresas selecionadas",
                "devices": "Insira o número de dispositivos selecionados",
                "files": "Insira o número de arquivos selecionados",
                "groups": "Insira o número de grupos selecionados",
                "productCodes": "",
                "tasks": "Insira o número de tarefas selecionadas",
                "users": "Insira o número de usuários selecionados"
            },
            "merge companies confirmation": "",
            "move companies confirmation": "",
            "move devices confirmation": "",
            "number of lines": "",
            "selected 20 or more devices": "",
            "transfer devices confirmation": ""
        },
        "confirm cannot revert": "Esta ação não pode ser revertida.",
        "confirm merge companies": "Tem certeza de que deseja mesclar essas empresas?",
        "count": "Contar",
        "create company": "Adicionar empresa",
        "create company description": "",
        "create desktop license": "",
        "create desktop license description": "",
        "create group": "",
        "create group description": "",
        "create model": "",
        "create model description": "",
        "create offline license": "",
        "create or edit group description": "Firmware e configuração podem ser atribuídos ao grupo. Assim que isso for feito, as tarefas de atualização de firmware e / ou configuração serão geradas para todos os membros do grupo (dispositivos).",
        "create role": "",
        "create role description": "",
        "create smart group": "",
        "create smart group banner message": "",
        "create smart group description": "",
        "create task description first step": "",
        "create task description last step": "",
        "current level": "",
        "custom resource limits": {
            "at least one limit must be higher": "",
            "configuration files per device": "",
            "confirmation modal description": "",
            "confirmation modal title": "",
            "count": {
                "companies count": "",
                "configuration files per device count": "",
                "tasks per group count": "",
                "users count": ""
            },
            "explanations": {
                "companies": "",
                "configuration files per device": "",
                "tasks per group": "",
                "users": ""
            },
            "main modal description": "",
            "resources limit type": "",
            "revert custom resource limits": "",
            "revert custom resource limits description": "",
            "revert custom resource limits description confirmation": "",
            "revert custom resource limits title": "",
            "revert custom resource limits title confirmation": "",
            "tasks per group": ""
        },
        "date range": "",
        "date to": "",
        "delete companies": "Excluir empresas",
        "delete deviceModels": "",
        "delete files": "Excluir arquivos",
        "delete file warning": "",
        "delete groups": "Excluir grupos",
        "delete productCodes": "",
        "delete roles": "",
        "delete tasks and history": "",
        "delete users": "Excluir usuários",
        "description": "Descrição",
        "desktop license delete description": "",
        "desktop license name": "",
        "device identifier": "",
        "device transfer": {
            "main": {
                "description": "",
                "title": ""
            },
            "receive devices": {
                "copy token": "",
                "description": "",
                "token info": ""
            },
            "transfer devices": {
                "confirmation": "",
                "device token": "",
                "transfer from file": ""
            }
        },
        "device transfer token": "",
        "downgrading company level is not possible": "",
        "download sample file message": "",
        "edit group banner message": "",
        "edit group description": "",
        "edit role description": "",
        "edit smart group description": "",
        "email": "",
        "enter": "",
        "enter code": "",
        "enter description": "",
        "enter name": "",
        "example": "Ex.:",
        "expires at": "",
        "explanation": "",
        "export device data": "",
        "export device description": "",
        "export file format": "",
        "feature": "",
        "feature control": "Controle de funcionalidades",
        "field disabled until company selected": "",
        "firmware": "",
        "files to download": "",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "",
                "bluetooth_authorization_list": ""
            },
            "endings": {
                "file": "",
                "files": ""
            },
            "fail": {
                "multiple": "",
                "single": ""
            },
            "success": {
                "multiple": "",
                "single": ""
            }
        },
        "filtered": "Filtrado",
        "filtered companies": "Empresas filtradas",
        "filtered devices": "Dispositivos filtrados",
        "filtered files": "Arquivos filtrados",
        "filtered groups": "Grupos filtrados",
        "filtered tasks": "Tarefas filtradas",
        "filtered users": "Usuários filtrados",
        "find tool": {
            "device": {
                "error not valid": "",
                "error subtitle": "",
                "error title": "",
                "link": "",
                "no permission": ""
            },
            "user": {
                "error not valid": "Formato de email inválido",
                "error subtitle": "",
                "error title": "",
                "link": "",
                "no permission": ""
            }
        },
        "firmware date": "Data do firmware",
        "from form": "De formulário",
        "from file": "De arquivo",
        "general": "Gerais",
        "gsm_number": "",
        "iccid": "",
        "imei": "IMEI",
        "imei restriction": "",
        "import device data": "",
        "import device data description": "",
        "import device data info": "",
        "import device data limit": "",
        "imsi": "",
        "input text too long": "",
        "invalid hardware key": "",
        "invalid imei": "IMEI errado",
        "invalid ipv4": "",
        "invalid serial": "Número serial errado",
        "invalid value": "Valor inválido",
        "inverted selection": "",
        "invite user": "",
        "invite user description": "",
        "invite user max roles": "",
        "log files": "Registro de arquivos",
        "make": "",
        "manage permissions": "",
        "maximum value is": "",
        "merge companies": "Mesclar empresas",
        "merge companies info": "",
        "merge companies disabled option": {
            "client to internal": "",
            "internal": "",
            "lz code": ""
        },
        "minimum value is": "",
        "move companies disabled option": {
            "internal": ""
        },
        "move device": "Mover dispositivo",
        "move device description": "",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Mover dispositivos",
        "name": "Nome",
        "newest": "Do mais recente",
        "no dropdown files": {
            "description": "Para selecionar esta opção, carregue um novo arquivo de $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "",
                "adas_firmware": "",
                "ble_fw": "firmware BLE",
                "blue_nrg": "firmware BlueNrg",
                "bluetooth_authorization_list": "",
                "can_chip_firmware": "",
                "carrier_advance_firmware": "firmware da Carrier Advance",
                "carrier_advance_settings": "configurações da Carrier Advance",
                "carrier_apx_firmware": "firmware da Carrier APX",
                "carrier_apx_settings": "configurações da Carrier APX",
                "certificate": "certificado",
                "configuration": "configuração",
                "dsm_firmware": "",
                "dtb": "",
                "firmware": "firmware",
                "fw_bundle": "",
                "gnssm_download_assistant": "",
                "gnssm_firmware": "",
                "main configuration": "",
                "manual_geofence_list": "",
                "meig_modem_firmware": "",
                "netprisma_modem_firmware": "firmware do modem NETPRISMA",
                "psub": "subscrição",
                "quectel_modem_firmware": "firmware do modem Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Nenhum arquivo de $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "",
        "obd oem": "OBD OEM",
        "offline license delete description": "",
        "oldest": "Do mais antigo",
        "only integers": "",
        "only numbers": "Apenas números são válidos",
        "optional": "",
        "other companies": "",
        "parent company": "Empresa-mãe",
        "permission preset": "",
        "platform compatibility": {
            "banner text": "",
            "compatible model devices": "",
            "count text": "",
            "create tasks for incompatible devices": "",
            "devices from file": "",
            "platform": "",
            "task applies": "",
            "task cannot be created": ""
        },
        "receiving company": "",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "",
            "banner description": "",
            "description": "",
            "title": ""
        },
        "revision": "",
        "revision value error": "",
        "role name": "",
        "root company": "",
        "sales email": "",
        "scheduled time warning": "",
        "schedule task": "",
        "select": "Selecionar",
        "select at least one": {
            "companies": "",
            "devices": "Selecione pelo menos um dispositivo",
            "files": "Selecione pelo menos um arquivo",
            "groups": "Selecione pelo menos um grupo",
            "tasks": "Selecione pelo menos uma tarefa",
            "users": ""
        },
        "selected": "Selecionado",
        "selected companies": "Empresas selecionadas",
        "selected deviceModels": "",
        "selected devices": "Dispositivos selecionados",
        "selected files": "Arquivos selecionados",
        "selected groups": "Grupos selecionados",
        "selected productCodes": "",
        "selected roles": "",
        "selected tasks": "Tarefas selecionadas",
        "selected users": "Usuários selecionados",
        "select company": "",
        "select group": "",
        "select time interval": "",
        "selected time window": "",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "",
            "title": ""
        },
        "sn": "Número serial",
        "specific": "Específico",
        "time period": "",
        "time period custom": "",
        "tls certificate transfer info": "",
        "token has expired": "",
        "token is valid": "",
        "transfer companies": "",
        "transfer companies description": "",
        "transfer devices": "",
        "tri source": {
            "selected tab description": {
                "create task": "",
                "general": ""
            },
            "filtered tab description": {
                "create task": "",
                "general": ""
            },
            "from file tab description": {
                "create task": "",
                "general": ""
            }
        },
        "unlocker": {
            "generate unlock key": "",
            "generate unlock key description": "",
            "invalid lock code": "",
            "limit reached": "",
            "lock code": "",
            "select device platform": "",
            "select device platform description": "",
            "unlock key": "",
            "unlock key success message": ""
        },
        "upload file": "",
        "upload file description": "",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "",
        "upload firmware unsupported info": "",
        "use at least one filter": "Use pelo menos um filtro",
        "user": "",
        "valid until": "",
        "valid until date disable description": "",
        "vehicle model": "Modelo"
    },
    "Dropzone": {
        "add file": "",
        "add files": "",
        "drop file to upload": "",
        "drop files to upload": "",
        "error uploading the file": "",
        "file invalid type": "",
        "file successfully uploaded": "",
        "file syntax": "A sintaxe do arquivo é a seguinte:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "",
        "only one file can be attached": "",
        "or drop file to upload": "",
        "or drop files to upload": "",
        "rows detected": "",
        "select file": "",
        "select files": "",
        "select file type": "Selecione o tipo de arquivo primeiro.",
        "supported formats": "",
        "too long file name": "",
        "too many files description": "",
        "too many files title": ""
    },
    "Error": {
        "error": "",
        "message wait": "Aguarde até que consertemos o erro.",
        "title": "Algo deu errado!"
    },
    "Feature highlight": {
        "got it": "Entendi",
        "new feature": "Novo recurso!",
        "scenarios description": "Agora você pode definir um dos seguintes cenários no seu dispositivo: Excesso de Velocidade, Detecção de colisão ou Detecção de reboque."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Status",
        "all permissions": "",
        "batch_id": "ID de lote",
        "company_id": "Empresa",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Criado por",
        "current_configuration": "Configuração",
        "current_firmware": "Firmware",
        "device_imei": "IMEI do dispositivo",
        "file type": "Tipo do arquivo",
        "filtered by": "",
        "filters used": "",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Grupo",
        "id": "ID",
        "Invalid company": "",
        "model": "Modelo",
        "model_platform": "",
        "Multiple companies": "",
        "parent company": "Empresa-mãe",
        "permission": "",
        "permission status": "",
        "role": "",
        "spec_id": "",
        "status_id": "Status",
        "supported_task_type": "",
        "table filters": "",
        "task type": "",
        "task_queue": "",
        "type": "Tipo",
        "user status": ""
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "",
        "ADAS firmware is invalid.": "",
        "All notifications were deleted.": "Todas as notificações foram deletadas.",
        "All notifications were marked as read.": "Todas as notificações foram marcadas como lidas.",
        "At least one user role must be provided.": "",
        "Attributes length is invalid": "",
        "Banner was updated.": "",
        "Batch was discarded": "",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "",
        "Bulk create job was created. Devices will be created shortly.": "O trabalho de criação em massa foi criado. Os dispositivos serão criados em breve.",
        "Bulk create job was created. Tasks will be created shortly.": "O trabalho de criação em massa foi criado. As tarefas serão criadas em breve.",
        "Bulk delete job was created. Companies will be removed shortly.": "O trabalho de exclusão em massa foi criado. As empresas serão removidas em breve.",
        "Bulk delete job was created. Devices will be removed shortly.": "O trabalho de exclusão em massa foi criado. Os dispositivos serão removidos em breve.",
        "Bulk delete job was created. Files will be removed shortly.": "O trabalho de exclusão em massa foi criado. Os arquivos serão removidos em breve.",
        "Bulk delete job was created. Groups will be removed shortly.": "O trabalho de exclusão em massa foi criado. Os grupos serão removidos em breve.",
        "Bulk delete job was created. Product codes will be removed shortly.": "",
        "Bulk delete job was created. Users will be removed shortly.": "O trabalho de exclusão em massa foi criado. Os usuários serão removidos em breve.",
        "Bulk task create job was created. Tasks will be created shortly.": "",
        "Bulk update job was created. Devices will be updated shortly.": "Trabalho de atualização em massa foi criado. Os dispositivos serão atualizados em breve.",
        "Bulk update job was created. Tasks will be updated shortly.": "Trabalho de atualização em massa foi criado. As tarefas serão atualizadas em breve.",
        "Can adapter was added.": "Adaptador CAN foi adicionado.",
        "Can adapter was deleted.": "Adaptador CAN foi deletado.",
        "Can adapter was updated.": "Adaptador CAN foi atualizado.",
        "Can chip firmware file size can't be zero": "",
        "Can chip firmware is invalid.": "",
        "Cannot delete company. Company is not empty.": "",
        "Cannot delete file. It is used by pending or running tasks.": "",
        "Cannot delete file. It is used by running tasks.": "",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "",
        "check your email for details": "",
        "Companies count limit exceeded.": "",
        "Companies in the request must belong to the selected root.": "",
        "Company merge job was created. It will be merged shortly.": "A tarefa de fusão da empresa foi criada. Ela será mesclada em breve.",
        "Company name already exist.": "",
        "Company level change is not allowed.": "",
        "Company level successfully changed": "",
        "company level successfully reverted": "",
        "Company not allowed to be merged": "",
        "company resource limits changed": "",
        "Company was created.": "Empresa foi criada.",
        "Company was deleted.": "Empresa foi deletada.",
        "Company was updated.": "Empresa foi atualizada.",
        "compatibilities added": "",
        "compatibilities synchronized": "",
        "Configuration cannot have FOTA functionality disabled": "",
        "Configuration file cannot contain duplicate parameters": "",
        "Configuration file size can't be zero": "",
        "Configuration files count limit exceeded.": "",
        "Configuration version must be defined": "",
        "custom resource limits successfully reverted": "",
        "Custom roles feature is not enabled.": "",
        "desktop license added": "",
        "Devices already are in target company": "",
        "Device already exists.": "O dispositivo já existe.",
        "Device bulk attribute update file cannot be empty": "",
        "Device bulk attribute update file should be .csv": "",
        "Device export limit reached. You can not export more than 100000 devices": "",
        "Device import limit reached. You can not import more than 100 devices": "",
        "Device model and task type compatibility was updated.": "",
        "Device model was created.": "",
        "Device model was deleted.": "",
        "Device model was updated.": "",
        "Device not found": "",
        "Device Transfer job was created. Devices will be transfered shortly.": "",
        "Device was added.": "Dispositivo foi adicionado.",
        "Device was deleted.": "Dispositivo foi excluído.",
        "Device was updated.": "Dispositivo foi atualizado.",
        "Email or password is incorrect.": "E-mail ou senha está incorreto(-a).",
        "Failed to create Product code": "",
        "Failed to delete Product code": "",
        "Failed to import devices.": "",
        "Failed to Read Product code": "",
        "Failed to retry failed tasks": "",
        "Failed to update Product code": "",
        "Failed to update task for retry": "",
        "Field is not valid": "",
        "File description is too long. Max 255 characters allowed.": "",
        "File exceeds entries limit of 10000.": "",
        "File must not contain duplicated IMEIs": "",
        "File must not contain IMEIs that already exist in database.": "",
        "File must not contain invalid IMEIs": "",
        "File name is too long. Max 255 characters allowed.": "",
        "File name should not contain illegal characters or symbols": "",
        "File not found": "",
        "File was deleted.": "Arquivo foi deletado.",
        "File was successfully uploaded.": "O arquivo foi carregado com sucesso.",
        "File was updated.": "O arquivo foi atualizado.",
        "File was uploaded. Devices will be imported shortly.": "O arquivo foi carregado. Os dispositivos serão importados em breve.",
        "File will be created shortly. Check files in a second.": "O arquivo será criado em breve. Verifique os arquivos em um segundo.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "",
        "First device in file not found.": "",
        "Forbidden": "Proibido.",
        "Group name already exist.": "",
        "Group was added.": "\"'{{group}}'\" criado com sucesso.",
        "Group was created.": "Grupo foi criado.",
        "Group was deleted.": "Grupo foi deletado.",
        "Group was updated.": "Grupo foi atualizado.",
        "Invalid device bulk update attribute": "",
        "Invalid email address.": "",
        "Invalid file contents": "",
        "Invalid file name": "",
        "Invalid invitation token.": "Token de convite inválido.",
        "Invalid token": "",
        "Invalid token length": "",
        "Internal Server Error": "",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "",
        "License was updated.": "",
        "Maximum companies hierarchy depth exceeded": "",
        "Maximum device group size exceeded.": "",
        "Method Not Allowed": "",
        "Network Error": "Erro de rede.",
        "No changes made": "Nenhuma mudança foi feita.",
        "No resources found.": "",
        "not allowed to affect batch": {
            "description": "",
            "title": {
                "approve": "",
                "discard": ""
            }
        },
        "Not Found": "Não encontrado.",
        "Notification was deleted.": "A notificação foi deletada.",
        "notify when done title": "",
        "Obd record was created.": "O registro OBD foi criado.",
        "Obd record was updated.": "O registro OBD foi atualizado.",
        "offline license added": "",
        "Offline license was deleted.": "",
        "Only id_list source is supported.": "",
        "Only users with Teltonika email can be invited into internal companies.": "",
        "Only users with Teltonika email can be moved into internal companies.": "",
        "Parent company cannot be a descendant of the updated company.": "",
        "Password reset link was sent to Your email.": "O link de redefinição de senha foi enviado para o seu e-mail.",
        "Password reset token is invalid, expired or related user no longer exists.": "O token de redefinição de senha é inválido, expirou ou o usuário não existe mais.",
        "Password was changed.": "A senha foi alterada.",
        "product code added": "",
        "Product code is too long. Max 200 characters allowed.": "",
        "ProductCode already exists.": "",
        "ProductCode not found": "",
        "Product code was deleted.": "",
        "Product code was updated.": "",
        "Retry failed tasks job was created": "",
        "Role cannot be set for an internal user.": "",
        "Role was created.": "",
        "Role was deleted.": "",
        "Role was updated.": "",
        "selected company changed": "Empresa selecionada foi alterada.",
        "Selected firmware bundle is not supported by the device.": "",
        "Server Error": "Erro do servidor.",
        "SMS was sent.": "SMS foi enviado.",
        "Something went wrong while saving a new password.": "Algo deu errado ao salvar uma nova senha.",
        "Successfully logged out.": "Desconectado com sucesso.",
        "System Admin user level is required in order to perform this action.": "O nível de usuário System Admin é necessário para executar esta ação.",
        "Target company cannot be a descendant of source company.": "",
        "Task create limit exceeded.": "",
        "Task type is not retriable": "",
        "Task was added.": "A tarefa foi adicionada.",
        "task was created": "A tarefa foi criada para {{imei}} (\"{{taskType}}\").",
        "Task was updated.": "A tarefa foi atualizada.",
        "Tasks were approved": "As tarefas foram aprovadas.",
        "The given data was invalid.": "Os dados fornecidos são inválidos.",
        "time zone changed": "O fuso horário foi alterado.",
        "Token cannot be null or empty": "",
        "token created": "O token foi criado.",
        "Token has expired": "",
        "Token's and token's owner companies do not match": "",
        "Token was deleted.": "O token foi deletado.",
        "Too many resources in the request": "",
        "Too Many Requests": "",
        "Transfer token created": "",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "",
        "Two factor authentication successfully disabled.": "",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Incapaz de enviar SMS. Este dispositivo não possui um número GSM atribuído.",
        "Unable to validate Your request.": "Incapaz de validar o seu pedido.",
        "Unauthenticated.": "Não autenticado.",
        "Unauthorized": "Não autorizado.",
        "User access level is not valid": "",
        "User invitation was revoked": "O convite de usuário foi revogado.",
        "User invitation was re-sent": "O convite de usuário foi reenviado.",
        "User is already in the system.": "O usuário já está no sistema.",
        "User was created.": "Usuário foi criado.",
        "User was deleted.": "Usuário foi deletado.",
        "User was invited.": "Usuário foi convidado.",
        "User was updated": "Usuário foi atualizado.",
        "Users count limit exceeded.": "",
        "Your password has been changed.": "Sua senha foi alterada."
    },
    "General": {
        "0": "",
        "5": "",
        "10": "",
        "15": "",
        "19": "",
        "20": "",
        "99": "",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "",
        "Company.Delete": "",
        "Company.Merge": "",
        "Company.Update": "",
        "Device.Export": "",
        "Device.Read": "",
        "Device.SecretsRead": "",
        "Device.Transfer": "",
        "Device.Unlock": "",
        "Device.Update": "",
        "DeviceGroup.Create": "",
        "DeviceGroup.Delete": "",
        "DeviceGroup.Read": "",
        "DeviceGroup.Update": "",
        "File.Create": "",
        "File.Delete": "",
        "File.Download": "",
        "File.Read": "",
        "File.TctWebAccess": "",
        "File.Update": "",
        "Role.Create": "",
        "Role.Delete": "",
        "Role.Read": "",
        "Role.Update": "",
        "Task.Create": "",
        "Task.Read": "",
        "Task.Retry": "",
        "Task.Update": "",
        "TaskGroup.Read": "",
        "TctIntegration.Access": "",
        "Token.Create": "",
        "Token.Delete": "",
        "Token.Read": "",
        "User.Create": "",
        "User.Delete": "",
        "User.Read": "",
        "User.Update": "",
        "--- END-OF-PERMISSIONS ---": "",
        "1-wire authorization list": "",
        "1_wire_authorization_list": "",
        "Active": "",
        "adas_firmware": "",
        "apx_firmware": "Firmware APX",
        "assign can package": "",
        "assigned package": "",
        "automatic": "",
        "banner management": "",
        "batches": "Grupos de tarefas",
        "black_box": "Caixa preta",
        "ble_dtb": "",
        "ble_fw": "Firmware BLE",
        "blue_nrg": "Firmware BlueNRG",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "",
        "bluetooth_authorization_list": "",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "",
                "true": ""
            },
            "web_editor_support": {
                "false": "",
                "true": ""
            }
        },
        "can": "",
        "can adapter name": "",
        "can bootstring": "Número do Bootstring",
        "can configuration": "",
        "can_debug_log": "",
        "can oem file package": "",
        "can oem file vehicle": "",
        "can package": "",
        "can program number": "",
        "can revision": "",
        "can software date": "",
        "can type": "",
        "Cancelled": "Cancelado",
        "cancel task": "Cancelar tarefa",
        "can_chip_firmware": "",
        "carrier_advance_firmware": "Firmware da Carrier Advance",
        "carrier_advance_settings": "Configurações da Carrier Advance",
        "carrier_apx_firmware": "Firmware da Carrier APX",
        "carrier_apx_settings": "Configurações da Carrier APX",
        "carrier_extractions": "Extrações da Carrier",
        "carrier_logger_files": "",
        "certificate": "Certificado",
        "click for more details": "",
        "client ip": "",
        "clone model": "",
        "collapse menu": "",
        "companies": "Empresas",
        "company": "Empresa",
        "company level": "",
        "company type": "",
        "company name": "Nome da empresa",
        "Completed": "Concluído",
        "Completed with errors": "Concluído com erros",
        "configuration": "Configuração",
        "configuration_36": "Configuração (FM36)",
        "configuration_64": "Configuração (FMB64)",
        "crash_dump": "",
        "created at": "Criado em",
        "created by": "Criado por",
        "custom": "",
        "custom resource limits": "",
        "dashboard": "",
        "delete desktop license": "",
        "delete offline license": "",
        "desktopLicenses": "",
        "device_export_file_csv": "Arquivo de exportação do dispositivo (.csv)",
        "device_export_file_xlsx": "Arquivo de exportação do dispositivo (.xlsx)",
        "deviceModels": "",
        "deviceModelTaskCompatibilities": "",
        "device_transfer_report": "",
        "device group": "",
        "DeviceImportFile": "Arquivo de importação de dispositivo",
        "devices": "Dispositivos",
        "download file": "Fazer download do arquivo",
        "download offline license": "",
        "dsm_firmware": "",
        "dtb": "",
        "edit compatibility": "",
        "edit model": "",
        "edit company": "Editar empresa",
        "edit desktop license": "",
        "edit device": "Editar dispositivo",
        "edit file": "Editar arquivo",
        "edit group": "Editar grupo",
        "edit in tct web": "",
        "edit in tct web disabled": "",
        "edit product code": "",
        "edit role": "",
        "edit smart group": "",
        "edit user": "Editar usuário",
        "Empty": "Vazios",
        "enter here": "",
        "exception_info": "",
        "Executing": "",
        "expand menu": "",
        "Expired": "Vencido",
        "Factory": "",
        "Failed": "Falhou",
        "file": "Arquivo",
        "file data": "",
        "files": "Arquivos",
        "file deleted": "Arquivo foi deletado",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "",
        "fw_bundle_ble": "",
        "fw_bundle_ble_dtb": "",
        "fw_bundle_can": "",
        "fw_bundle_can_dtb": "",
        "fw_bundle_dtb": "",
        "fw_bundle_mainfw": "",
        "generic": "",
        "global_configuration": "Configuração Global",
        "global_firmware": "Firmware Global",
        "gnssm_download_assistant": "",
        "gnssm_firmware": "",
        "group": "Grupo",
        "groups": "Grupos de dispositivos",
        "hardware key": "",
        "id": "ID",
        "id_collection_file": "Arquivo de coleta de ID",
        "imei restriction": "",
        "Inactive": "Inativo",
        "Invalid": "",
        "invalid model": "",
        "invalid model_name": "",
        "InvitationExpired": "",
        "InvitationPending": "",
        "Legacy": "",
        "legacy model": "",
        "legacy model_platform": "",
        "legacy platform": "",
        "license has expired": "",
        "loading": "Carregando",
        "log": "Registro",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "",
        "ManualGeofenceList": "",
        "manual geofence list": "",
        "manual_geofence_list": "",
        "meig_modem_firmware": "",
        "menu": "",
        "modem version": "",
        "netprisma_modem_firmware": "Firmware do modem NETPRISMA",
        "nmea_log": "",
        "no": "",
        "no results": "Nenhum resultado inicial encontrado",
        "no results description": "",
        "not assigned": "Não atribuído",
        "not assigned configuration_file_id": "",
        "not assigned current_configuration": "",
        "not assigned current_firmware": "",
        "not assigned firmware_file_id": "",
        "not assigned group_id": "",
        "not assigned model": "",
        "not assigned spec_id": "",
        "not assigned task_type": "",
        "obd_chip_firmware": "",
        "obd chip firmware version": "",
        "Offline": "",
        "offline licenses": "",
        "Online": "",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "",
        "other": "",
        "Pending": "Pendente",
        "Pending approval": "",
        "permission disabled": "",
        "permission enabled": "",
        "productCodes": "",
        "psub": "Arquivo de subscrição",
        "quectel_fw": "Firmware do modem Quectel (quectel_fw)",
        "quectel_modem_firmware": "Firmware do modem Quectel",
        "resend invite": "",
        "restricted": "",
        "retry": "",
        "roles": "",
        "Running": "Funcionando",
        "RxAutoscan": "",
        "RxBlackBox": "Receber caixa preta",
        "RxBluetoothAuthorizationList": "",
        "RxCanDebugLog": "",
        "RxCarrierExtractions": "Baixar extrações da Carrier",
        "RxCarrierLoggerFiles": "",
        "RxConfiguration": "Receber configuração",
        "RxCrashDump": "",
        "RxExceptionInfo": "",
        "RxLog": "Receber registro interno",
        "RxManualGeofenceList": "",
        "RxNmeaLog": "",
        "RxOneWireAuthorizationList": "",
        "RxWdLog": "Receber registro de watchdog (WD)",
        "select company": "Selecione empresa",
        "SetBindSim": "Ligar o dispositivo ao (s) cartão (ões) SIM atual (is)",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Desativar recurso",
        "SetEnableFeature": "Habilitar recurso",
        "SetForceLockSim": "Forçar bloqueio do SIM",
        "SetUnbindSim": "Desvincular dispositivo com cartão (s) SIM",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Status",
        "task details": "",
        "task groups": "Grupos de tarefas",
        "tasks": "Grupos de tarefas",
        "tasksCompatibility": "",
        "task type": "Tipo de tarefa",
        "Tct": "",
        "time zone": "Fuso horário",
        "total": "Total",
        "tutorials": "",
        "TxAdasFirmware": "",
        "TxAgpsMt3333": "Transferir arquivo AGPSM",
        "TxAgpsQuectelL89": "Transferir arquivo AGPSQ",
        "TxAutoscanCanConfiguration": "",
        "TxBleFirmware": "",
        "TxBlueNrgFirmware": "",
        "TxBluetoothAuthorizationList": "",
        "TxBundleBle": "",
        "TxBundleBleDtb": "",
        "TxBundleCan": "",
        "TxBundleCanDtb": "",
        "TxBundleDtb": "",
        "TxBundleFirmware": "",
        "TxCanAdapterModeChange": "Alterar o modo do adaptador CAN externo",
        "TxCanAdapterModeChangeInternal": "Alterar o modo do adaptador CAN interno",
        "TxCanAdapterUpdate": "",
        "TxCanAdapterUpdateInternal": "Atualizar adaptador CAN interno",
        "TxCanChipFirmware": "",
        "TxCanConfiguration": "",
        "TxCarrierAdvanceFirmware": "Atualizar o firmware da Carrier Advance",
        "TxCarrierAdvanceSettings": "Atualizar as configurações da Carrier Advance",
        "TxCarrierApxFirmware": "Atualizar firmware da Carrier APX",
        "TxCarrierApxSettings": "Atualizar configurações da Carrier APX",
        "TxConfiguration": "",
        "TxDsmFirmware": "",
        "TxDtb": "",
        "TxFirmware": "",
        "TxFirmwareBundle": "",
        "TxFirmwareBundleParts": "",
        "TxFotaCertificate": "",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "",
        "TxGNSSMFirmware": "",
        "TxManualGeofenceList": "",
        "TxMeigModemDeltaFirmware": "",
        "TxNetprismaModemDeltaFirmware": "",
        "TxObdChipFirmware": "",
        "TxObdConfig": "Transferir arquivo de configuração OBD",
        "TxOneWireAuthorizationList": "",
        "TxPSub": "Transferir arquivo de subscrição",
        "TxQuectelModemDeltaFirmware": "",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "",
        "users": "Usuários",
        "Unknown": "",
        "unknown": "",
        "unknown model_platform": "",
        "unknown origin": "",
        "unknown platform": "",
        "unrestricted": "",
        "Verifying": "",
        "vin": "VIN",
        "vip status": "",
        "wd_log": "Registro WD",
        "yes": ""
    },
    "Maintenance": {
        "title": ""
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "",
            "Cancel tasks action failed. No resources found.": "",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "",
            "Create device group tasks action failed. No resources found.": "",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "",
            "Create tasks action failed. No resources found.": "",
            "Create tasks action failed. No resources processed.": "",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "",
            "Delete companies action failed. No resources found.": "",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "",
            "Delete files action failed. No resources found.": "",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "",
            "Delete groups action failed. No resources found.": "",
            "Delete product codes action failed. No resources found.": "",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "",
            "Delete users action failed. No resources found.": "",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "",
            "{{DevicesCount}} device(s) imported.": "",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "",
            "Export devices action failed. No resources found.": "",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "",
            "Invalid request scope. Resources must belong to single root.": "",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "",
            "{{ProcessedCount}} device group(s) deleted.": "",
            "{{ProcessedCount}} device attribute(s) updated.": "",
            "{{ProcessedCount}} device model(s) deleted.": "",
            "{{ProcessedCount}} device(s) updated.": "",
            "{{ProcessedCount}} file(s) deleted.": "",
            "{{ProcessedCount}} product code(s) deleted.": "",
            "{{ProcessedCount}} task(s) canceled.": "",
            "{{ProcessedCount}} task(s) updated.": "",
            "{{ProcessedCount}} user(s) deleted.": "",
            "Retry tasks action failed. No resources found.": "",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "",
            "Transfer devices action failed. No resources found.": "",
            "Transfer devices action failed. No resources processed.": "",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "",
            "Update devices action failed. No resources found.": "",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "",
            "Update devices attributes action failed. No resources found.": "",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "",
            "Update tasks action failed. No resources found.": "",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Sem notificações",
        "notifications": "Notificações",
        "notifications will be listed": "",
        "remove notification": "",
        "see previous notifications": "",
        "timestamps": {
            "days ago": "",
            "hours ago": "",
            "minutes ago": "",
            "moments ago": ""
        },
        "title": {
            "BackgroundActionFailed": "",
            "CompaniesSuccessfullyDeleted": "",
            "CompanyBulkDeleteFailed": "",
            "CompanyLevelChanged": "",
            "CompanyLevelDowngradeReminder": "",
            "CompanyMergeFailed": "",
            "CompanySuccessfullyMerged": "",
            "DeviceAttributesSuccessfullyUpdated": "",
            "DeviceBulkAttributeUpdateFailed": "",
            "DeviceBulkUpdateFailed": "",
            "DeviceExportFailed": "",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "",
            "DeviceGroupTasksSuccessfullyCreated": "",
            "DeviceModelBulkDeleteFailed": "",
            "DeviceModelsSuccessfullyDeleted": "",
            "DevicesSuccessfullyTransferred": "",
            "DevicesSuccessfullyUpdated": "",
            "DeviceTransferFailed": "",
            "ExportFailed": "Falha na exportação do recurso",
            "ExportSucceeded": "",
            "FailedTasksRetryFailed": "",
            "FailedTasksSuccessfullyRetried": "",
            "FileBulkDeleteFailed": "",
            "FilesSuccessfullyDeleted": "",
            "GroupBulkDeleteFailed": "",
            "ImportFailed": "Falha na importação do recurso",
            "ImportSucceeded": "",
            "ProductCodeBulkDeleteFailed": "",
            "ProductCodesSuccessfullyDeleted": "",
            "ResourceUpdateFailed": "Falha na atualização do recurso",
            "ResourceUpdateSucceeded": "Atualização do recurso feita com sucesso",
            "RoleBulkDeleteFailed": "",
            "RolesSuccessfullyDeleted": "",
            "TaskBulkCancelFailed": "",
            "TaskBulkCreateFailed": "",
            "TaskBulkUpdateFailed": "",
            "TaskGroupSuccessfullyCreated": "",
            "TasksPropagationFailed": "O trabalho de propagação da tarefa falhou",
            "TasksPropagationSucceeded": "Propagação de tarefas efetuado com sucesso",
            "TasksPropagationWarning": "",
            "TasksSuccessfullyCanceled": "",
            "TasksSuccessfullyUpdated": "",
            "UserBulkDeleteFailed": "",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": ""
        }
    },
    "Permission actions": {
        "Access": "",
        "Create": "",
        "Delete": "",
        "Download": "",
        "Export": "",
        "Merge": "",
        "Read": "",
        "Retry": "",
        "SecretsRead": "",
        "TctWebAccess": "",
        "Transfer": "",
        "Unlock": "",
        "Update": ""
    },
    "Permission groups": {
        "company": "",
        "device": "",
        "device group": "",
        "file": "",
        "role": "",
        "task": "",
        "task group": "",
        "token": "",
        "user": ""
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "",
                "token list": ""
            },
            "custom_role_support": {
                "create role": "",
                "edit role": "",
                "edit user": ""
            },
            "task_schedule_support": {
                "table head": ""
            }
        },
        "general message": "",
        "resource_limit_settings": {
            "tasks_per_group": ""
        }
    },
    "Search": {
        "code": "",
        "description": "",
        "email": "",
        "iccid": "",
        "id": "",
        "imei": "",
        "model": "",
        "name": "",
        "product code": "",
        "role name": "",
        "serial": "",
        "search by": "",
        "search company name": ""
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "",
                    "title": ""
                },
                "send email code": {
                    "enter code": ""
                },
                "send otp code": {
                    "description": "",
                    "no access": {
                        "authenticator": "",
                        "email": ""
                    }
                },
                "title": ""
            },
            "get email code": {
                "description": "",
                "description modal": "",
                "title": ""
            },
            "get secret code": {
                "description": ""
            },
            "select authentication type": {
                "authentication app description": "",
                "description": "",
                "description modal": "",
                "email": "",
                "email description": "",
                "recommended": "",
                "title": "",
                "title modal": ""
            },
            "send email code": {
                "description": "",
                "enter code": "",
                "title": "",
                "verification code": ""
            },
            "send otp code": {
                "click to scan code": "",
                "click to type code": "",
                "incorrect code": "",
                "scan QR code": "",
                "six digit code": "",
                "title": "",
                "type text code": ""
            },
            "settings": {
                "description": "",
                "disabled": "",
                "enabled": "",
                "title": ""
            },
            "success message": {
                "alert": "",
                "description": "",
                "title": "",
                "title modal": ""
            },
            "title": {
                "authentication app": "",
                "authentication email": "",
                "is enabled": "",
                "protect your account": ""
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Alterar senha",
            "enter current password": "",
            "enter new password": "",
            "hide password": "",
            "repeat new password": "",
            "rules": {
                "lowercase letter": "",
                "minimum characters": "",
                "new and current passwords must not match": "",
                "new passwords must match": "",
                "number": "",
                "passwords must match": "",
                "special symbol": "",
                "uppercase letter": ""
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": ""
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "",
        "statistics message": "",
        "activity": "",
        "model": "Modelo",
        "firmware": "Firmware",
        "configuration": "Configuração",
        "statistics": "Estatisticas"
    },
    "Table": {
        "1_wire_authorization": "",
        "access group": "",
        "access groups": "",
        "access level": "",
        "accessories": "",
        "action": "",
        "action date": "",
        "assigned package": "",
        "attempt count": "Contagem de tentativas",
        "attribute": "Atributo",
        "attributes": "Atributos",
        "auto sync": "",
        "batch id": "ID de lote",
        "ble_dtb": "",
        "ble_fw": "Firmware BLE",
        "bluetooth_authorization": "",
        "bootloader": "",
        "can_adapter": "Adaptador CAN",
        "can adapter name": "",
        "can bootstring": "Número do Bootstring",
        "can oem file package": "",
        "can oem file vehicle": "",
        "can package": "",
        "can program number": "",
        "can software date": "",
        "can type": "",
        "carrier module id": "ID do Módulo",
        "carrier revision": "Revisão",
        "carrier serial id": "ID serial",
        "carrier settings filename": "Arquivo de configurações",
        "carrier unit status": "Status",
        "carrier unit type": "Tipo",
        "changed at": "",
        "change origin": "",
        "changes": "Alterações",
        "checkbox disabled": {
            "role": ""
        },
        "child company": "<0>Filial de</0><1>{{parentCompany}}</1>",
        "child companies": "",
        "code": "Código",
        "company": "Empresa",
        "company hierarchy": "Hierarquia da empresa",
        "company name": "",
        "compatibility": "",
        "configuration": "Configuração",
        "configuration details": "",
        "configuration type": "",
        "created at": "Criado em",
        "created by": "Criado por",
        "date": "Data",
        "description": "Descrição",
        "device details": "",
        "device company": "",
        "device description": "",
        "device group": "",
        "device imei": "IMEI do dispositivo",
        "device model": "Modelo do dispositivo",
        "device seen at": "Dispositivo visto em",
        "device serial": "N.º de série do dispositivo",
        "devices": "Dispositivos",
        "devices count": "",
        "Done": "Concluído",
        "download at": "",
        "download file": "",
        "dtb": "",
        "edit file": "Editar arquivo",
        "edit group banner": "",
        "email": "Email",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "",
                    "changes": "",
                    "companies": "",
                    "configurationChanges": "",
                    "desktopLicenses": "",
                    "devices": "",
                    "files": "",
                    "groups": "",
                    "offlineLicenses": "",
                    "permissions": "",
                    "productCodes": "",
                    "roles": "",
                    "tasks": "",
                    "users": ""
                },
                "title": {
                    "batches": "",
                    "changes": "",
                    "companies": "",
                    "configurationChanges": "",
                    "desktopLicenses": "",
                    "devices": "",
                    "files": "",
                    "groups": "",
                    "offlineLicenses": "",
                    "permissions": "",
                    "productCodes": "",
                    "roles": "",
                    "tasks": "",
                    "users": ""
                }
            },
            "no permission": {
                "description": "",
                "title": ""
            },
            "no results found": {
                "description": "",
                "title": ""
            },
            "button": {
                "add": {
                    "companies": "",
                    "devices": "",
                    "files": "",
                    "groups": "",
                    "productCodes": "",
                    "tasks": "",
                    "users": ""
                },
                "reset view": ""
            }
        },
        "exausted autoscan limit": "",
        "exausted vin parsing limit": "",
        "expiration": "",
        "expiration date": "",
        "expires at": "",
        "expiry date": "",
        "field": "",
        "file": "Arquivo",
        "file id": "ID do arquivo",
        "files": "Arquivos",
        "file type": "Tipo do arquivo",
        "filter by": "Filtrar por",
        "firmware": "Firmware",
        "general": "Geral",
        "general data": "",
        "gnss version": "",
        "group": "Grupo",
        "groups": "Grupos de dispositivos",
        "group vip status": "",
        "gsm number": "",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": ""
            },
            "platform": {
                "fmx platform": "",
                "ft platform": "",
                "legacy platform": "",
                "title": ""
            },
            "visibility": ""
        },
        "iccid": "",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "",
        "info": "Informação",
        "interface": "",
        "invited by": "Convidado por",
        "items": "",
        "last checked at": "",
        "last sign in": "",
        "last status update": "",
        "last used at": "",
        "license disabled": "",
        "license enabled": "",
        "license key": "",
        "license name": "",
        "links": "",
        "manual_geofence_scenarios": "",
        "message": "",
        "model": "Modelo",
        "model task type support": {
            "false": "",
            "true": ""
        },
        "modem version": "",
        "name": "Nome",
        "new value": "",
        "next task": "Próxima tarefa",
        "no changes": "Sem alterações.",
        "no company name": "Sem nome da empresa",
        "no details": "Sem detalhes",
        "no file": "Nenhum arquivo",
        "no imei available": "Sem IMEI disponível",
        "no model": "Sem modelo",
        "no parent company": "Empresa-mãe inexistente.",
        "no tasks": "O dispositivo não tem tarefas.",
        "number": "Número",
        "obd": "OBD",
        "obd chip firmware version": "",
        "of": "de",
        "offline licenses tab disabled": "",
        "original value": "",
        "other information": "",
        "page of": "página de",
        "parent company": "Empresa-mãe",
        "permission count": "",
        "platform": "",
        "Price": "Preço",
        "product code": "",
        "program number": "Número do programa",
        "property": "",
        "queue": "",
        "receiving company": "",
        "revision": "",
        "role": "",
        "role name": "",
        "rows per page": "",
        "running": "Funcionando",
        "schedule": "",
        "seen at": "Visto em",
        "select row": "",
        "send sms": "Enviar SMS",
        "serial": "Número serial",
        "show details": {
            "desktopLicenses": "",
            "devices": "",
            "batches": "",
            "tasks": "",
            "companies": ""
        },
        "sim": "",
        "size": "Tamanho",
        "software date": "Data do software",
        "source company": "Empresa de origem",
        "spec_id": "Espec. ID",
        "status": "Status",
        "status id": "ID do status",
        "status name": "Nome do status",
        "supported task types": "",
        "synced at": "",
        "table columns": "Colunas de tabela",
        "target company": "Empresa de destino",
        "task id": "",
        "task queue": "",
        "tasks": "Tarefas",
        "task type": "Tipo de tarefa",
        "tct web support": "",
        "total": "Total",
        "type": "Tipo",
        "updated at": "Atualizado em",
        "updated by": "Atualizado por",
        "unknown": "Desconhecido",
        "user cannot be deleted": "",
        "user cannot be edited": "",
        "user cannot delete himself": "",
        "user date statuses": {
            "expired": "",
            "expires": "",
            "never expires": "",
            "sent": ""
        },
        "user email": "",
        "user invitation cannot be cancelled": "",
        "user invitation cannot be resent": "",
        "user statuses": {
            "Active": "",
            "Inactive": "",
            "InvitationExpired": "",
            "InvitationPending": ""
        },
        "users": "Usuários",
        "value from": "",
        "value to": "",
        "view all roles": "",
        "vin": "VIN",
        "vip status": "",
        "visibility": ""
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "",
                    "type": ""
                },
                "can": {
                    "assigned package": "",
                    "can oem file package": "",
                    "can oem file vehicle": "",
                    "dtb": "",
                    "firmware": ""
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "",
                    "program number": "",
                    "revision": "",
                    "software date": "",
                    "type": ""
                },
                "configuration details": {
                    "1_wire_authorization": "",
                    "bluetooth_authorization": "",
                    "main configuration": "",
                    "manual_geofence_scenarios": ""
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "",
                    "bluetooth password": "",
                    "bootloader": "",
                    "company": "",
                    "configuration": "",
                    "description": "",
                    "dtb": "",
                    "firmware": "",
                    "gnss version": "",
                    "group": "",
                    "product code": "",
                    "serial": ""
                },
                "obd": {
                    "obd chip firmware version": "",
                    "vin": ""
                },
                "sim": {
                    "gsm number": "",
                    "iccid": "",
                    "imsi": ""
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "",
                    "id": "",
                    "invited by": "",
                    "role": "",
                    "updated at": ""
                }
            }
        },
        "user details": ""
    },
    "Task groups": {
        "all": "Todos os lotes",
        "bulk type": {
            "CompanyBulkDelete": "Deletar empresa",
            "DeviceBulkCreate": "Adicionar dispositivo",
            "DeviceBulkDelete": "Deletar dispositivo",
            "DeviceBulkUpdate": "Atualizar dispositivo",
            "FileBulkDelete": "Deletar arquivo",
            "GroupBulkDelete": "Deletar grupo",
            "TaskBulkCreate": "Criar tarefa",
            "TaskBulkUpdate": "Cancelar tarefa",
            "UserBulkDelete": "Deletar usuário"
        },
        "pending approval": "Aprovação pendente",
        "already approved": "Já aprovado",
        "no approval required": "Não é necessário aprovar",
        "total objects": "Objetos totais",
        "total tasks": ""
    },
    "Task status": {
        "0": "Pendente",
        "1": "Funcionando",
        "2": "Concluído",
        "3": "Concluído com erros",
        "4": "Cancelado",
        "5": "Falhou",
        "6": "Vencido",
        "7": "",
        "8": "",
        "task count": {
            "0": "",
            "1": "",
            "3": "",
            "5": ""
        },
        "verified tooltip title": ""
    },
    "Tasks": {
        "0": "A tarefa está na fila e agora está pendente.",
        "1": "A tarefa está em execução no momento.",
        "2": "A tarefa foi concluída com sucesso.",
        "3": "A tarefa foi concluída, mas ocorreram alguns erros.",
        "4": "A tarefa foi cancelada.",
        "5": "A tarefa falhou.",
        "6": "A tarefa não foi concluída em um determinado prazo."
    },
    "Tct": {
        "edit configuration": "",
        "no editable configurations": "",
        "open tct": "",
        "open tct description": "",
        "select configuration file": "",
        "tct web": "",
        "tct web disabled description": ""
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
